import React, { useEffect, useRef, useState } from 'react';
import { css } from 'aphrodite/no-important';
import s from './InstagramFeed.style';

const POSTS = [
  'https://www.instagram.com/p/DITMRtuI-mu/',
  'https://www.instagram.com/p/DaaVEF6CLim/',
  'https://www.instagram.com/p/DRiN3z7iF61/',
];

const isReactSnap =
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.indexOf('ReactSnap') !== -1;

const loadInstagramScript = () => {
  if (document.getElementById('instagram-embed-script')) {
    if (window.instgrm && window.instgrm.Embeds) {
      window.instgrm.Embeds.process();
    }
    return;
  }

  const script = document.createElement('script');
  script.id = 'instagram-embed-script';
  script.async = true;
  script.defer = true;
  script.src = 'https://www.instagram.com/embed.js';
  script.onload = () => {
    if (window.instgrm && window.instgrm.Embeds) {
      window.instgrm.Embeds.process();
    }
  };
  document.body.appendChild(script);
};

const InstagramFeed = () => {
  const sectionRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (isReactSnap) {
      return;
    }

    if (!sectionRef.current) {
      return;
    }

    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      setShouldLoad(true);
      return;
    }

    const observer = new window.IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px', threshold: 0 }
    );

    observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (shouldLoad) {
      loadInstagramScript();
    }
  }, [shouldLoad]);

  return (
    <div className={css(s.section)} ref={sectionRef}>
      <h2 className={css(s.title)}>Kövess Instagramon</h2>
      <div className={css(s.grid)}>
        {POSTS.map(url => (
          <div key={url} className={css(s.item)}>
            <blockquote
              className={css(s.embed) + ' instagram-media'}
              data-instgrm-permalink={url}
              data-instgrm-version="14"
            >
              <a href={url} target="_blank" rel="noopener noreferrer">
                Instagram post
              </a>
            </blockquote>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InstagramFeed;
